import React, {  useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './RevenueComponent.metadata.json5';

import styles from "../DirectorsAndOfficers.module.scss"
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function RevenueComponent(props) {

const { submissionVM, updateWizardData,pathUpdated} = props;
const breakpoint = useContext(BreakpointTrackerContext);
const { onValidate } = useValidation('RevenueComponent');
const modelVM = _.get(submissionVM, pathUpdated)
  
  modelVM.value.isValidationReq = true

   const calTotalGrossRevAndAssests = useCallback(() =>{
      const grossRevenue = _.get(modelVM, 'groRev2.value') !== null ? _.get(modelVM, 'groRev2.value'): 0
      const grossTotalAssets = _.get(modelVM, 'groTotAss3.value') !== null ? _.get(modelVM, 'groTotAss3.value'): 0
      const totalGrossRevandAssets = grossRevenue + grossTotalAssets
  
      _.set(modelVM, 'totGroRevTotAss4.value', totalGrossRevandAssets) 
   },[modelVM]);

// eslint-disable-next-line react-hooks/exhaustive-deps
  const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        }
    };


const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM,pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM,`${fullPath}`,value);

            
            if(changedPath === 'groRev2' || changedPath === 'groTotAss3'){
                calTotalGrossRevAndAssests()
            }
            
            updateWizardData(submissionVM);         
        },
        [calTotalGrossRevAndAssests, pathUpdated, submissionVM, updateWizardData]
    );

return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={modelVM}
                resolveValue={readValue}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                onValueChange={handleValueChange}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
    );


}

RevenueComponent.propTypes = wizardProps;
export default withRouter(RevenueComponent);
